module.exports = __webpack_public_path__ + "img/college_button.a01b3064.png";